module.exports = __webpack_public_path__ + "img/board-game.20b09578.png";